// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cf5004bc","772":"c81e710a","850":"314e6c6c"}[chunkId] + ".chunk.js";
};